<template lang="html">
  <section id="question" class="no-pad">
    <div class="aha-question">
      <h1 class="no-pad" v-if="this.$route.name == 'english'">Do you have a question?</h1>
      <h1 class="no-pad" v-else>Haben Sie auch eine Frage?</h1>
      <form id="aha-form" v-if="!submitted" action="https://send.pageclip.co/SZzQs2FEnDCpvSPoEocdmSzVG81GR9gG" class="pageclip-form" method="post">
        <input type="text" name="Fragen" placeholder="..." v-model="question">
        <!-- <textarea-autosize
            :max-height="600"
            v-model="question"
            name="fragen"
            placeholder="..."
        ></textarea-autosize> -->
        <button class="pageclip-form__submit" type="submit">
          <template v-if="this.$route.name == 'english'">Send</template>
          <template v-else>Senden</template>
        </button>
      </form>
      <div v-else>
        Thank you
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      question: '',
      errors: {
        name: '',
        email: '',
        question: ''
      },
      submitted: false
    }
  },
  methods: {
    // validate: function (e) {
    //   if (this.question) {
    //     this.submit()
    //   }
    //   this.errors.question = ''
    //   if (!this.question) {
    //     this.errors.question = 'Question required.'
    //   }
    // },
    // async submit () {
    //   pageclip.send({some: 'data'}).then((response) => {
    //     console.log(response.status, response.data) // => 200, [Item, Item]
    //   }).then(() => {
    //     return pageclip.fetch()
    //   }).then((response) => {
    //     console.log(response.status, response.data) // => 200, [Item, Item]
    //   })
    // }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.aha-question-toggle {
  padding-bottom:$gap / 2;
}
#aha-form {
  div {
    position: relative;
    span {
      position:absolute;
      bottom: $gap / 2;
      right:0;
      font-size:$font-size / 3;
    }
  }
  textarea, input {
    border:0;
    width:100%;
    height:auto;
    font-family: $font-family;
    font-size: $font-size;
    line-height: $line-height * 1.2;
    background:$bgcolor;
    color:$font-color;
    padding: $gap / 4 0;
    margin-bottom:0;
    resize:none;
    border-radius: 0;
    // overflow:auto;
    border-bottom: 2px solid $font-color;
    &::placeholder {
      color: $color2;
      margin:0;
      padding:0;
    }
    @media only screen and (max-width: $phone) {
      border-bottom: 1px solid $font-color;
      font-size: $font-size / 2;
      padding: $gap / 2 0;
    }
    &:focus {
      outline:none;
    }
  }
  button {
    background:$bgcolor;
    border:0;
    color:$font-color;
    font-family: $font-family;
    font-size: $font-size;
    line-height: $line-height;
    padding: $gap / 4 0 0;
    cursor:pointer;
    border-bottom: 2px solid $bgcolor;
    &:hover {
      border-bottom: 2px solid $font-color;
    }
    @media only screen and (max-width: $phone) {
      padding: $gap / 2 0 0;
      font-size: $font-size / 2;
    }
    &:focus {
      outline:none;
    }
  }
}
</style>
